<template>
    <a :href="fileDownload" class="btn btn--dense btn--icon-inline">
        <svg-vue icon="document-file-download" class="icon"/>
    </a>
</template>

<script>

export default {
    name: 'FileDownload',
    props: {
        sketchFile: Object,
        cadFile: Object
    },
    computed: {
        fileDownload() {
            if (this?.sketchFile?.id)
                return this?.sketchFile?.id ? this.$$route('sketch-file.download', {'sketchFile': this?.sketchFile?.id}) : '';

            if (this?.cadFile?.id)
                return this?.cadFile?.id ? this.$$route('cad-file.download', {'cadFile': this?.cadFile?.id}) : '';

            return '';

        },
    }
};
</script>

